import { useState, useEffect, useRef } from 'react'

export default function FooterSearch() {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const timerRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (query.length < 2) {
      setResults([])
      setIsOpen(false)
      return
    }

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(async () => {
      try {
        const res = await fetch(`/search?q=${encodeURIComponent(query)}`)
        const data = await res.json()
        setResults(data.results)
        setIsOpen(data.results.length > 0)
      } catch {
        setResults([])
      }
    }, 300)

    return () => clearTimeout(timerRef.current)
  }, [query])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsOpen(false)
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  return (
    <div ref={containerRef}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => results.length > 0 && setIsOpen(true)}
        placeholder="Search..."
        aria-label="Search"
        className="w-full rounded-lg bg-white/90 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:outline-none"
      />

      {isOpen && results.length > 0 && (
        <div className="mt-2 rounded-lg bg-white text-gray-800 shadow-lg">
          <div className="px-2 py-2 max-h-80 overflow-y-auto">
            {results.map((r) => (
              <a
                key={`${r.entry_type}-${r.entry_id}`}
                href={r.url}
                className="block py-2 px-2 hover:bg-gray-50 rounded"
              >
                <div className="flex items-center gap-2">
                  <span className="text-xs text-gray-400 shrink-0 w-10">
                    {r.entry_type === 'day_piece' ? 'Day' : 'Topic'}
                  </span>
                  <span className="text-sm font-medium text-gray-800 truncate">
                    {r.title}
                  </span>
                </div>
                {r.snippet && (
                  <p
                    className="text-xs text-gray-500 mt-0.5 ml-12 line-clamp-2"
                    dangerouslySetInnerHTML={{ __html: r.snippet }}
                  />
                )}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
